import API from '../../api/api';

import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function getDatiByTokenInBank(token,codiceBroker,apiPath) {  
  return (dispatch) => {
    const params = {
      service: 'login',
      DATA: token
    }
    API.getAxios(apiPath).get(`/integration`, {params:params})
      .then(response => {
        /*
        * In caso di Token valido:
        * - Continuo il processo di preventivo compilando i campi con quelli ricevuti dal Token.
        */
        dispatch({type: actionTypes.INIT_TOKEN_INBANK, payload: {cb:codiceBroker, data:response.data.data}});
      })
      .catch(errore => {
        /*
        * In caso di Token non valido:
        * - Viasualizzo Messaggio di Warning
        * - Continuo il processo di preventivo senza auto compilare i campi.
        */
        message.warning(`${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
        dispatch({type: actionTypes.INIT_TOKEN_INBANK, payload: {cb:codiceBroker, data:null}});
      })
  };
}

export default getDatiByTokenInBank;